<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <time-range-picker ref="timeRangePicker" :model="filterFormModel" @input="load" :label="$t('time')"
                               :default-shortcut="6" class="mr-1"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1">{{ $t('search') }}</button>
          </div>
        </div>
        <div class="tile">
          <div class="table-responsive c-template-table">
            <table class="table table-hover table-bordered">
              <thead>
              <tr>
                <th></th>
                <th class="text-center">{{ $t('call') }}</th>
                <th class="text-center">{{ $t('duration') }}</th>
                <th class="text-center">{{ $t('billDuration') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr class="bg-success">
                <td><b class="text-uppercase">{{ $t('total') }}</b></td>
                <td class="text-center"><span class="text-blue">{{ sum.call | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.duration | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.billDuration | callDuration }}</span></td>
              </tr>
              <tr class="bg-warning">
                <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                <td class="text-center"><span class="text-blue">{{ avg.call | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.duration | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.billDuration | callDuration }}</span></td>
              </tr>
              <tr :key="index" v-for="(item, index) in data">
                <td style="min-width: 200px"><b>{{ item._id }}</b></td>
                <td class="text-center"><span class="text-blue">{{ item.call | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.duration | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.billDuration | callDuration }}</span></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TimeRangePicker from '../../components/TimeRangePicker'
import moment from 'moment'

export default {
  components: { TimeRangePicker },
  data: function() {
    return {
      filterFormModel: {},
      loading: true,
      data: [],
      sum: 0,
      avg: 0
    }
  },
  methods: {
    load() {
      let loader = this.$loading.show()
      this.loading = true
      if (!this.filterFormModel.to || !this.filterFormModel.from) {
        this.filterFormModel.from = moment().startOf('month').format('x')
        this.filterFormModel.to = moment().endOf('month').format('x')
      }
      this.$service.get('/admin-call/statistical', {
        params: this.filterFormModel
      }).then(response => {
        this.data = response.data
        this.sum = {}
        this.avg = {}
        this.data.forEach(item => {
          for (let key in item) {
            item[key] = Math.abs(item[key])
            if (!this.sum[key]) {
              this.sum[key] = 0
            }
            this.sum[key] += Math.abs(item[key])
          }
        })
        for (let key in this.sum) {
          this.avg[key] = Math.round(this.sum[key] / this.data.length)
        }
      }).finally(() => {
        loader.hide()
        this.loading = false
      })
    }
  },
  mounted() {
    this.load()
  },
  i18n: {
    messages: {
      en: {
        call: 'Call',
        duration: 'Total duration (s)',
        billDuration: 'Talk duration (s)'
      },
      vi: {
        call: 'Cuộc gọi',
        duration: 'Thời lượng (s)',
        billDuration: 'Thời gian đàm thoại (s)'
      }
    }
  }
}
</script>